import React, { useState } from 'react';
import { MdOutlineRestore } from "react-icons/md";
import { Button } from 'antd';
import { ICellRendererParams } from 'ag-grid-community';
import { useDispatch } from 'react-redux';
import { updateHistoryLogsSelectionData } from '@/features/selectedDataSlice';
import { handleRevertAction } from '@/ts/utils';

interface IRevertActionCellRendererParams extends ICellRendererParams {
    disableAction?: boolean
}

const RevertActionCellRenderer: React.FC<IRevertActionCellRendererParams> = (params) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState<boolean>(false);
    const handleRevertActionClick = async () => {
        try {
            setLoading(true);
            dispatch(updateHistoryLogsSelectionData([params.data]));
            await handleRevertAction();
            setLoading(false);
        } catch (err: any) {
            setLoading(false);
        }
    }

    return (
        <>
            <div>
                <Button
                    id={`${params.data.id}-revert-action-btn`}
                    icon={<MdOutlineRestore
                        fill="#1F4172"
                        style={{
                            width: "30px"
                        }}
                    />}
                    onClick={handleRevertActionClick}
                    loading={loading}
                    disabled={params.data.change_type.includes("addition")}
                >
                </Button>
            </div>
        </>
    )
}

export default RevertActionCellRenderer